import React from 'react'
import { useTranslation } from 'react-i18next'
import CopyButton from '../components/CopyButton';
import NextSectionCard from '../components/NextSectionCard';
import { timeSince } from '../utils/timeSince';
import PreviousSectionCard from '../components/PreviousSectionCard';
import tutorialIcon from "../assets/icons/tutorial.svg";
import { Trans } from "react-i18next";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import error from "../assets/image/messageBox/error.jpg";
import warning from "../assets/image/messageBox/warning.png";

const MessBox = () => {
    const { t, i18n } = useTranslation();
    const lastUpdated = "2026-03-05";
    const lang = i18n.language;

    const buildCopyText = (t) => {
        const clean = (key) =>
            t(key)?.replace(/<[^>]+>/g, "").trim() || "";

        return `
${clean("sidebar.usage.messageBox")}

${clean("messageBox.error")}
- ${clean("messageBox.errorItem1")}
- ${clean("messageBox.errorItem2")}
- ${clean("messageBox.errorItem3")}

${clean("messageBox.warning")}
- ${clean("messageBox.warningItem1")}
- ${clean("messageBox.warningItem2")}

${clean("messageBox.ok")}
- ${clean("messageBox.okItem1")}
- ${clean("messageBox.okItem2")}
`.trim();
    };
    return (
        <div className="text-black dark:text-white">
            <div
                className="
          desktop:px-4
          py-3
          max-w-3xl
        "
            >
                <div className="relative flex items-center justify-between gap-3">
                    <div className="flex items-center gap-1">
                        <div>
                            <img src={tutorialIcon} alt="tutorial" className="w-6 h-6" />
                        </div>
                        <div>
                            <p className="text-[16px] tabletpro:text-[12px] mini_mobile:text-[14px] text-[#0087FE] font-normal">
                                {t("sidebar.usage.title").toUpperCase()}
                            </p>
                        </div>
                    </div>

                    <CopyButton text={buildCopyText(t)} />
                </div>

                <div className="mt-2 relative">
                    <section className='flex gap-4'>
                        <p className='text-[#020617] dark:text-[#F8FAFC] text-[40px] tabletpro:text-[22px] mini_mobile:text-[24px] mobile:text-[30px] font-semibold'>{t("sidebar.usage.messageBox")}</p>
                    </section>

                    <section className='flex flex-col gap-4 mt-1'>
                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="messageBox.error"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <ul className="list-disc pl-6 space-y-1">
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                {t("messageBox.errorItem1")}
                            </li>
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                {t("messageBox.errorItem2")}
                            </li>
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                {t("messageBox.errorItem3")}
                            </li>
                        </ul>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: error

                        }}>
                            <img
                                src={error}
                                alt="error"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="messageBox.warning"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <ul className="list-disc pl-6 space-y-1">
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                {t("messageBox.warningItem1")}
                            </li>
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                {t("messageBox.warningItem2")}
                            </li>
                        </ul>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: warning

                        }}>
                            <img
                                src={warning}
                                alt="warning"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="messageBox.ok"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <ul className="list-disc pl-6 space-y-1">
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                {t("messageBox.okItem1")}
                            </li>
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                {t("messageBox.okItem2")}
                            </li>
                        </ul>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: error

                        }}>
                            <img
                                src={error}
                                alt="error"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>
                    </section>

                    <section className='flex gap-4 mt-4 flex-col desktop:flex-row'>
                        <PreviousSectionCard
                            label={t("sidebar.usage.viewCert")}
                            to="/login-gopaperlessagent"
                        />
                        <NextSectionCard
                            label={t("sidebar.usage.supportedSign")}
                            to="/supported-sign"
                        />
                    </section>

                    {/* Last updated */}
                    <section className='flex gap-4 mt-4'>
                        <span className="text-[14px] text-[#64748B]">
                            {t("welcome.lastUpdatedBase")} {timeSince(lastUpdated, lang)}
                        </span>
                    </section>
                </div>

            </div>
        </div>

    )
}

export default MessBox
